import { mergeClassnames } from '@heathmont/moon-core-tw';
import useFavouriteToggle from '~/client/components/Game/GameView/shared/hooks/useFavouriteToggle';
import GenericStar from '@/external/icons/GenericStar';

const FavouriteToggle: FC = () => {
  const { isFavourite, handleClick } = useFavouriteToggle();
  return (
    <div
      className="cursor-pointer"
      data-testid="game-header-toggle-favourite"
      onClick={handleClick}
    >
      <GenericStar
        className={mergeClassnames(
          'text-moon-24',
          isFavourite ? 'fill-krillin text-krillin' : 'fill-trunks text-trunks',
        )}
      />
    </div>
  );
};

export default FavouriteToggle;
